import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import {
  FilteredSearchFilters,
  FilteredSearchMatches,
  Autocomplete,
  AutocompleteGlossary,
} from '../'
import { routeNames } from '../../routes'
import searchIcon from '../../assets/icons/magnifying-glass.svg'
import './FilteredSearchDashboard.sass'


class FilteredSearchDashboard extends Component {
  state = {
    redirectUrl: null
  }

  constructor() {
    super()

    this._renderBody = this.renderBody.bind(this)
    this._onAutocompleteSelect = this.onAutocompleteSelect.bind(this)
  }

  onAutocompleteSelect(e, { suggestion: selected }) {
    this.setState({ redirectUrl: `${routeNames.tool}${selected.slug}`})
  }

  renderInputComponent(inputProps) {
    return (
      <div className="search-field">
        <input type="input" {...inputProps} />
        <div className="image-wrapper">
          <img src={searchIcon} alt="magnifying glass" />
        </div>
      </div>
    )
  }

  renderBody() {
    const { filters, activeTabIdx, setActiveFilterIds, activeFilterIds } = this.props
    const filtersBucketKey = activeTabIdx === 0 ? 'top_filters' : 'more_filters'

    switch (activeTabIdx) {
      case 0:
      case 1:
        return (
          <FilteredSearchFilters
            filters={filters[filtersBucketKey]}
            activeFilterIds={activeFilterIds}
            setActiveFilterIds={setActiveFilterIds}
          />
        )

      default:
        return <FilteredSearchMatches matches={this.props.matches} fetchMatches={this.props.fetchMatches} />
    }
  }

  render() {
    const {
      activeTabIdx,
      setActiveFilterTab,
      matches,
      allTools,
      glossary,
      isLoadingGlossary,
    } = this.props
    const { redirectUrl } = this.state
    const isFiltersView = activeTabIdx === 0 || activeTabIdx === 1

    if (redirectUrl) {
      return <Redirect to={redirectUrl} push={true} />
    }

    const showExactMatchesCount = matches.matchesCount || !matches.relevantCount
    const matchesCount = matches.matchesCount || 0

    return (
      <div className="filtered-search-dashboard">
        <div className="filtered-search-banner">
          <div className="tool-matches hide-on-mobile">
            {showExactMatchesCount ? 'Tool Matches' : 'Relevant Matches'}
            <span className="tool-matches-count">{showExactMatchesCount ? matchesCount : matches.relevantCount}</span>
            of {matches.totalCount || 0}
            { matches.isFetching && <div className="spinner-loader" /> }
          </div>
          { isFiltersView ?
            <div className="filtered-search__input-group">
              <div className="filtered-search__glossary-search">
                <AutocompleteGlossary glossaryTerms={glossary} disabled={isLoadingGlossary} />
              </div>
              <button type="button" className="btn-blue-transparent" onClick={() => setActiveFilterTab(2)}>view tool matches</button>
            </div> :
            <div className="search-field-container">
              <Autocomplete
                placeholder="Search by tool name..."
                allSuggestions={allTools}
                inputComponent={this.renderInputComponent}
                onSelect={this._onAutocompleteSelect}
              />
            </div>
          }
        </div>
        {this._renderBody()}
      </div>
    )
  }
}

FilteredSearchDashboard.propTypes = {
  activeTabIdx: PropTypes.number,
  setActiveFilterTab: PropTypes.func,
  fetchMatches: PropTypes.func,
  matches: PropTypes.object,
  filters: PropTypes.object,
  allTools: PropTypes.array,
  activeFilterIds: PropTypes.array,
  setActiveFilterIds: PropTypes.func
}

export default FilteredSearchDashboard
